import type { VoidFunctionComponent } from 'react';
import styles from './PublishSbomReportControl.module.less';
import { ErrorAlert } from '../../../../generic';
import { usePublishReport, useUnpublishReport } from './hooks';
import PublishButton from '../../shared/components/PublishButton';
import ReportStatus from '../../shared/components/ReportStatus';

type Props = {
  reportType: 'SBOM' | 'Attribution';
};

const PublishSBOMReportControl: VoidFunctionComponent<Props> = ({ reportType }: Props) => {
  const {
    unpublishReport,
    errors: unpublishReportErrors,
    isLoading: isLoadingUnpublishReport,
    isUnpublished: isUnpublishedButtonClicked,
  } = useUnpublishReport();
  const {
    publishReport,
    errors: publishReportErrors,
    isLoading: isLoadingPublishReport,
    isPublished: isPublishedButtonClicked,
  } = usePublishReport();
  const errors = [...unpublishReportErrors, ...publishReportErrors];

  return (
    <>
      <div className={styles.container}>
        <div>
          <div className={styles.header}>{reportType} Preview</div>
          <ReportStatus
            isLoading={isLoadingUnpublishReport}
            isDisabled={isUnpublishedButtonClicked}
            onUnpublishReport={unpublishReport}
            reportType={reportType}
          />
        </div>
        <PublishButton
          isLoading={isLoadingPublishReport}
          isPublished={isPublishedButtonClicked}
          onPublishReport={publishReport}
          reportType={reportType}
        />
      </div>
      <ErrorAlert status={{ errors }} />
    </>
  );
};

export default PublishSBOMReportControl;
